<div class="feature-quote-list-item-container">
  <div class="content">
    <div class="feature" *ngIf="entry.product as product">
      <div class="header">
        <div class="image {{isHealthy ? '' : 'error'}}">
          <img
            src="./assets/features/{{featureDetail?.productLogo?.toLowerCase()}}_feature.svg"
            alt="feature_icon_{{featureDetail?.productLogo?.toLowerCase()}}"
            title="feature_icon_{{featureDetail?.productLogo?.toLowerCase()}}" />
        </div>
        <div class="description">
          <div class="article-number">
             {{ 'basket.feature.articleNumber.headline' | translate }} {{ product.code }}
          </div>
          <div class="title">
            {{ product.name }}
          </div>
          <div class="subtitle">
            <ng-container *ngIf="isHealthy; else error"><markdown [data]="feature?.salesRule?.instruction"></markdown></ng-container>
            <ng-template #error>
              <span class="error">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <path fill="red" fill-rule="evenodd" d="M8 .571l8 14.858H0L8 .57zm0 2.411L1.913 14.286h12.174L8 2.982zM8.571 12v1.143H7.43V12H8.57zm0-5.714v4.571H7.43V6.286H8.57z"/>
                </svg>
                {{ 'basket.feature.error.notCompatible.headline' | translate }}
              </span>
            </ng-template>
          </div>
          <div class="error">
          </div>
        </div>
      </div>
      <div class="delete hideOnPhone">
        <ng-container *ngTemplateOutlet="deleteButton"></ng-container>
      </div>
      <div class="price hideOnPhone" *ngIf="product.price as price">
        {{ price.formattedValue }}
      </div>
      <div class="pricing showOnPhone">
        <div class="delete"> <ng-container *ngTemplateOutlet="deleteButton"></ng-container> </div>
        <div class="price" *ngIf="product.price as price">{{ price.formattedValue }}</div>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteButton>
  <div class="btn-delete" *ngIf="canDelete" (click)="deleteFeatureClicked()">
    <div tabindex="1" class="content">
      <div class="img">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path fill="#9B9B9E" fill-rule="evenodd" d="M5 5.714v10.414c0 .523.22.885.39.934l.039.006h9.142c.162 0 .393-.325.425-.822l.004-.118V5.714h1.429v10.414c0 1.259-.715 2.362-1.742 2.44l-.116.003H5.43c-1.05 0-1.802-1.058-1.855-2.304l-.003-.14V5.715H5zm8.571-4.285v1.428h2.858v1.429H3.57V2.857h2.857V1.429h7.143z"/>
        </svg>
      </div>
      <div class="description">
        {{ 'basket.feature.button.delete' | translate }}
      </div>
    </div>
  </div>
</ng-template>
